import { status } from "../untils";
import config from '../config-site'
import axios from 'axios';



AbortSignal.timeout ??= function timeout(ms) {
    const ctrl = new AbortController()
    setTimeout(() => ctrl.abort(), ms)
    return ctrl.signal
}

const address_api = config[0].address;

export function auth(credential){
    // return fetch(`${address_api}/api/authenticate/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: JSON.stringify(credential)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/authenticate/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
	    withCredentials: true,
        data: JSON.stringify(credential),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setlogin(userdata){
    // return fetch(`${address_api}/api/profile/setlogin/`, {
    //     method : 'POST',
    //     headers: {
    //         'Accept': '*/*',
    //         'Content-Type': 'application/json; charset=UTF-8'
    //     },
    //     body: JSON.stringify(userdata),
    //     signal: AbortSignal.timeout(25000)

    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/profile/setlogin/`,
        method: "post",
        headers: {
            'Accept': '*/*',
            // 'Authorization': `Token ${token}`,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getProfileExist(items){
    // return fetch(`${address_api}/api/profile/place_get/`, {
    //     method : 'POST',
    //     headers: {
    //         'Accept': '*/*',
    //         'Content-Type': 'application/json; charset=UTF-8',
    //     },
    //     body: JSON.stringify(items),
    //     signal: AbortSignal.timeout(25000)

    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/profile/place_get/`,
        method: "post",
        headers: {
            'Accept': '*/*',
            // 'Authorization': `Token ${token}`,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setCrfToken(credential){
    // return fetch(`${address_api}/api/token/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: JSON.stringify(credential)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/token/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
	    withCredentials: true,
        data: JSON.stringify(credential),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getCrfTokenRefresh(credential){
    // return fetch(`${address_api}/api/users/GET_VERIFY/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: JSON.stringify(credential)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/users/GET_VERIFY/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
	    withCredentials: true,
        data: JSON.stringify(credential),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function register(userdata){
    // return fetch(`${address_api}/api/users/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: JSON.stringify(userdata)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/users/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
	    withCredentials: true,
        data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getUser(token, userID){
    // return fetch(`${address_api}/api/users/getUserComments/?token=${token}&user=${userID}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     // body: JSON.stringify(userdata)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/users/getUserComments/?token=${token}&user=${userID}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getUsers(token, userID){
    let user_id = ''
    if (userID){
        user_id = `&user=${userID}`
    }
    // return fetch(`${address_api}/api/users/getUsers/?token=${token}${user_id}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     // body: JSON.stringify(userdata)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/users/getUsers/?token=${token}${user_id}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function userFirst(items){
    // return fetch(`${address_api}/api/userfirsts/place_set/`, {
    //     method : 'POST',
    //     headers: {
    //         'Accept': '*/*',
    //         'Content-Type': 'application/json; charset=UTF-8',
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //         // 'Authorization': `Token ${token}`
    //     },
    //     body: JSON.stringify(items),
    //     signal: AbortSignal.timeout(25000)

    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/userfirsts/place_set/`,
        method: "post",
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json; charset=UTF-8',
            // 'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function userEntry(token,  items){
    // return fetch(`${address_api}/api/userentrys/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: JSON.stringify(items)
    // }).then(status).catch( e => {console.log(e);})

    return axios({
        url: `${address_api}/api/userentrys/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        data: JSON.stringify(items),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getCaptcha(){
    // return fetch(`${address_api}/api/rest/captcha/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json; charset=UTF-8',
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //         // 'Authorization': `Token ${token}`
    //     },
    //     // body: JSON.stringify(items)
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/rest/captcha/`,
        method: "post",
        headers: {
            // 'Accept': '*/*',
            // 'Authorization': `Token ${token}`,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        // data: JSON.stringify({inbox}),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function ChangePass(userdata, userID, token){
    // return fetch(`${address_api}/api/users/${userID}/change_pass/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: JSON.stringify(userdata)
    // }).then(status).catch( e => {console.log(e);})

    return axios({
        url: `${address_api}/api/users/${userID}/change_pass/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getProfile(token){
    // return fetch(`${address_api}/api/profile/?token=${token}`, {
    //     method : 'GET',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     // body: data
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/profile/?token=${token}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function uploadAvatar(profileID, token, data){
    // return fetch(`${address_api}/api/profile/${profileID}/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/profile/${profileID}/`,
        method: "put",
        headers: {
            'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        // data: JSON.stringify(items),
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function updateProfile(userID, token, data){
    // return fetch(`${address_api}/api/users/${userID}/update_user/`, {
    //     method : 'PUT',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Token ${token}`,
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    //     body: JSON.stringify(data)
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/users/${userID}/update_user/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        data: JSON.stringify(data),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getSiteSetting(siteId){
    // return fetch(`${address_api}/api/sitesettings/?lang_id=${siteId}`)
    // .then(status).catch( e => {console.log(e);})
    // return fetch(`${address_api}/api/sitesettings/?lang_id=${siteId}`,{
    //     method : 'GET',
    //     headers: {
    //         'Access-Control-Allow-Origin': 'https://etec.ir'
    //     },
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sitesettings/?lang_id=${siteId}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getListSiteSetting(token){
    // return fetch(`${address_api}/api/sitesettings/`,{
    //     method : 'GET',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/sitesettings/`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function setSiteSetting(token, data){
    // return fetch(`${address_api}/api/sitesettings/`, {
    //     method : 'POST',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/sitesettings/`,
        method: "post",
        headers: {
            // 'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        // data: JSON.stringify(data),
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function updateSiteSetting(token, siteId, data, lang){
    // return fetch(`${address_api}/api/sitesettings/${siteId}/?lang_id=${lang}`, {
    //     method : 'PUT',
    //     headers: {
    //         'Authorization': `Token ${token}`,
    //     },
    //     body: data
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/sitesettings/${siteId}/?lang_id=${lang}`,
        method: "put",
        headers: {
            // 'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        // data: JSON.stringify(data),
        data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getLangSetting(lang){
    // return fetch(`${address_api}/api/lang_settings/${lang}`,{
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    // })
    // .then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/lang_settings/${lang}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getCountryList(){
    return fetch(`https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/index.json`)
    .then(status).catch( e => {console.log(e);})
}

export function setLangugeSetting(data){
    // return fetch(`${address_api}/api/countrys/`, {
    //     method : 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(data)
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/countrys/`,
        method: "put",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        data: JSON.stringify(data),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getLangugeId(country){
    // console.log(`${address_api}/api/countrys/?country=${country}`)
    // return fetch(`${address_api}/api/countrys/?country=${country}`, {
    //     method : 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     }
    // }).then(status).catch( e => {console.log(e);})
    return axios({
        url: `${address_api}/api/countrys/?country=${country}`,
        method: "get",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`
        },
	    withCredentials: true,
        // data: JSON.stringify(userdata),
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function delAllLangugeSetting(){
    // return fetch(`${address_api}/api/lang_settings/del_all/`, {
    //     method : 'POST',
    // }).then(status).catch( e => {console.log(e);})
    
    return axios({
        url: `${address_api}/api/lang_settings/del_all/`,
        method: "post",
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Token ${token}`,
        },
	    withCredentials: true,
        // data: JSON.stringify(data),
        // data: data,
        signal: AbortSignal.timeout(25000)
    }).then((res) => {
        return res?.data
    })
    .catch(e => {console.log(e?.message)});
}

export function getIPInfo(){
    // return fetch(`https://api.ipregistry.co/?key=tryout`, {
    return fetch(`http://ip-api.com/json/`, {
        method : 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(status).catch( e => {console.log(e);})
}
